import { Link } from 'react-router-dom';
import type { DbCategory } from '@/hooks/use-products';
import SafeImage from '@/components/SafeImage';

interface Props {
  category: DbCategory;
  priority?: boolean;
}

export default function CategoryCard({ category, priority = false }: Props) {
  return (
    <Link
      to={`/shop?category=${category.slug}`}
      className="group relative aspect-[4/3] overflow-hidden rounded-xl"
    >
      <SafeImage
        src={category.image || ''}
        alt={category.name}
        width={800}
        height={600}
        wrapperClassName="absolute inset-0 h-full w-full"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : undefined}
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 md:p-5">
        <h3 className="font-heading text-sm sm:text-lg md:text-xl font-semibold text-primary-foreground mb-0.5 md:mb-1 leading-tight break-words">
          {category.name}
        </h3>
        <p className="hidden sm:block text-xs md:text-sm text-primary-foreground/80 line-clamp-2">
          {category.description}
        </p>
      </div>
    </Link>
  );
}
